if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      this.decreaseBtn = this.querySelector('[data-action="decrease"]');
      this.increaseBtn = this.querySelector('[data-action="increase"]');
      this.decreaseBtn?.addEventListener('click', () => this.step(-1));
      this.increaseBtn?.addEventListener('click', () => this.step(1));
    }

    step(delta) {
      const min = parseInt(this.input.min || '1', 10);
      const current = parseInt(this.input.value || '1', 10);
      const next = Math.max(min, current + delta);
      this.input.value = String(next);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
